export const buchete_flori_column1 = [
    {
        id: "1",
        path: "/Buchete-flori/Buchete-de-orhidee",
        name: "Buchete de orhidee",
        cName: "nav-dropdown"
    },
    {
        id: "2",
        path: "/Buchete-flori/Buchete-de-trandafiri",
        name: "Buchete de trandafiri",
        cName: "nav-dropdown"
    },
    {
        id: "3",
        path: "/Buchete-flori/Buchete-de-lalele",
        name: "Buchete de lalele",
        cName: "nav-dropdown"
    },
    {
        id: "4",
        path: "/Buchete-flori/Buchete-de-minirosa",
        name: "Buchete de minirosa",
        cName: "nav-dropdown"
    },
    {
        id: "5",
        path: "/Buchete-flori/Buchete-de-crizanteme",
        name: "Buchete de crizanteme",
        cName: "nav-dropdown"
    },
    {
        id: "6",
        path: "/Buchete-flori/Buchete-de-garoafe",
        name: "Buchete de garoafe",
        cName: "nav-dropdown"
    },
    {
        id: "7",
        path: "/Buchete-flori/Buchete-cu-Hortensie",
        name: "Buchete cu Hortensie",
        cName: "nav-dropdown"
    },
]

export const buchete_flori_column2 = [
    {
        id: "8",
        path: "/Buchete-flori/Buchete-de-gerbera",
        name: "Buchete de gerbera",
        cName: "nav-dropdown"
    },
    {
        id: "9",
        path: "/Buchete-flori/Buchete-de-crini-imperiali",
        name: "Buchete de crini imperiali",
        cName: "nav-dropdown"
    },
    {
        id: "10",
        path: "/Buchete-flori/Buchete-de-crini-asiatici",
        name: "Buchete de crini asiatici",
        cName: "nav-dropdown"
    },
    {
        id: "11",
        path: "/Buchete-flori/Buchete-de-iris",
        name: "Buchete de iris",
        cName: "nav-dropdown"
    },
    {
        id: "12",
        path: "/Buchete-flori/Buchete-de-alstroemeria",
        name: "Buchete de alstroemeria",
        cName: "nav-dropdown"
    },
    {
        id: "13",
        path: "/Buchete-flori/Buchete-de-cale",
        name: "Buchete de cale",
        cName: "nav-dropdown"
    },
    {
        id: "14",
        path: "/Buchete-flori/Buchete-Mireasa",
        name: "Buchete Mireasa",
        cName: "nav-dropdown"
    },
]

export const buchete_flori_column3 = [
    {
        id: "15",
        path: "/Buchete-flori/Buchete-de-lisianthus",
        name: "Buchete de lisianthus",
        cName: "nav-dropdown"
    },
    {
        id: "16",
        path: "/Buchete-flori/Flori-de-Primavara",
        name: "Flori de Primavara",
        cName: "nav-dropdown"
    },
    {
        id: "17",
        path: "/Buchete-flori/Flori-de-Vara",
        name: "Flori de Vara",
        cName: "nav-dropdown"
    },
    {
        id: "18",
        path: "/Buchete-flori/Flori-de-Iarna",
        name: "Flori de Iarna",
        cName: "nav-dropdown"
    },
    {
        id: "19",
        path: "/Buchete-flori/Buchete-ambalate-in-cutie",
        name: "Buchete ambalate in cutie",
        cName: "nav-dropdown"
    },
    {
        id: "20",
        path: "/Buchete-flori/Buchete-cu-Bujori",
        name: "Buchete cu Bujori",
        cName: "nav-dropdown"
    },
]
